var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.75L7.5 36.25H32.5V3.75H7.5ZM5 36.25C5 37.6307 6.11929 38.75 7.5 38.75H32.5C33.8807 38.75 35 37.6307 35 36.25V3.75C35 2.36929 33.8807 1.25 32.5 1.25H7.5C6.11929 1.25 5 2.36929 5 3.75L5 36.25Z",
    fill: "#E1E1E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_10605)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.676 11.8453C18.3638 11.4661 19.1563 11.25 20 11.25C20.8437 11.25 21.6362 11.4661 22.324 11.8453L22.8271 11.3486C22.9603 11.2171 23.1761 11.2171 23.3093 11.3486C23.4424 11.48 23.4424 11.6931 23.3093 11.8245L22.9054 12.2232C24.0409 13.0845 24.7727 14.4387 24.7727 15.9615H15.2273C15.2273 14.4387 15.9592 13.0845 17.0947 12.2232L16.6907 11.8245C16.5577 11.6931 16.5577 11.48 16.6907 11.3486C16.8239 11.2171 17.0398 11.2171 17.1729 11.3486L17.676 11.8453ZM18.6364 13.9423C18.6364 14.314 18.3311 14.6154 17.9546 14.6154C17.578 14.6154 17.2727 14.314 17.2727 13.9423C17.2727 13.5706 17.578 13.2692 17.9546 13.2692C18.3311 13.2692 18.6364 13.5706 18.6364 13.9423ZM22.0455 14.6154C22.422 14.6154 22.7273 14.314 22.7273 13.9423C22.7273 13.5706 22.422 13.2692 22.0455 13.2692C21.6689 13.2692 21.3637 13.5706 21.3637 13.9423C21.3637 14.314 21.6689 14.6154 22.0455 14.6154Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.6443C12.5 17.0867 12.9579 16.6346 13.5227 16.6346C14.0876 16.6346 14.5455 17.0867 14.5455 17.6443V21.6827C14.5455 22.2403 14.0876 22.6923 13.5227 22.6923C12.9579 22.6923 12.5 22.2403 12.5 21.6827V17.6443Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 25.3846V27.7404C17.2727 28.298 17.7307 28.75 18.2955 28.75C18.8603 28.75 19.3182 28.298 19.3182 27.7404V25.3846H20.6818V27.7404C20.6818 28.298 21.1397 28.75 21.7046 28.75C22.2694 28.75 22.7273 28.298 22.7273 27.7404V25.3846H23.4091C24.1622 25.3846 24.7727 24.782 24.7727 24.0385V16.6346H15.2273V24.0385C15.2273 24.782 15.8378 25.3846 16.5909 25.3846H17.2727Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4546 17.6443C25.4546 17.0867 25.9125 16.6346 26.4773 16.6346C27.0421 16.6346 27.5 17.0867 27.5 17.6443V21.6827C27.5 22.2403 27.0421 22.6923 26.4773 22.6923C25.9125 22.6923 25.4546 22.2403 25.4546 21.6827V17.6443Z",
    fill: "#E1E1E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_10605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 17.5,
    fill: "white",
    transform: "translate(12.5 11.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletAndroid);
export default __webpack_public_path__ + "static/media/tablet_android.a4c0260d725ce7a1ca0bb74101d5343b.svg";
export { ForwardRef as ReactComponent };